import React from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import styles from './BoardTemplateBadge.less';

const format = forNamespace('board template badge');

export const BoardTemplateBadge = () => {
  return (
    <div
      className={styles.boardTemplateBadge}
      title={format('templates are read-only boards for others to copy')}
    >
      {format('template')}
    </div>
  );
};
